import { encodeBase32LowerCase } from '@oslojs/encoding';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import * as m from '$lib/paraglide/messages';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChild<T> = T extends { child?: any } ? Omit<T, 'child'> : T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChildren<T> = T extends { children?: any } ? Omit<T, 'children'> : T;
export type WithoutChildrenOrChild<T> = WithoutChildren<WithoutChild<T>>;
export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & { ref?: U | null };

export function scrollToSection(href: string) {
	const element = document.querySelector(href);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth' });
	}
}

export function generateId() {
	// ID with 120 bits of entropy, or about the same as UUID v4.
	const bytes = crypto.getRandomValues(new Uint8Array(15));
	const id = encodeBase32LowerCase(bytes);
	return id;
}

type MessageKey = keyof typeof m;

// Helper function type-safe
export function getLabel(category: string): string {
	// Vérifier si la clé existe dans m
	if (category in m && typeof m[category as MessageKey] === 'function') {
		return (m[category as MessageKey] as () => string)();
	}
	// Fallback si la catégorie n'existe pas
	return category;
}

export function generateAdminURI(sizeLimit: number = 5) {
	let randomURI = Math.ceil(Math.random() * (sizeLimit * 10000)).toString();
	if (+randomURI.length !== sizeLimit) {
		for (let index = 0; index < sizeLimit; index++) {
			if (!randomURI[index]) {
				randomURI += 'J';
			}
		}
	}
	return randomURI;
}

export function openCalendly() {
	const CALENDLY_URL = 'https://calendly.com/juslin03/30min';
	if ((window as any).Calendly) {
		(window as any).Calendly.initPopupWidget({ url: CALENDLY_URL });
	} else {
		window.open(CALENDLY_URL, '_blank');
	}
}
